import React from 'react';
import { useSelector } from 'react-redux';
import { userListConditionalRowStyles } from '../../../commonComponents/user-column';
import { CustomTable } from '../components/CustomTable';
import { DNTCustomFilters } from '../components/DNTCustomFilters';

export const DSOOfficeList = () => {
  const data = useSelector((state) => state.users.usersDSO);
  const count = useSelector((state) => state.users.countDSO);
  const searchParams = useSelector((state) => state.users.dsoSearchParams);

  return (
    <CustomTable
      title="DSO Offices"
      data={data}
      count={count}
      searchParams={searchParams}
      params={{ user_type: 'DNT', isDSO: true }}
      omitColumns={['Acct Standing', 'Average Rating', 'User Type']}
      conditionalRowStyles={userListConditionalRowStyles}
      CustomFilters={DNTCustomFilters}
    />
  );
};
